export default __webpack_public_path__ + "images/award.svg?2c6981401d47bb1cac02cf316619e003";